export class APIJson {
    constructor(response) {
        this._included = response.included;
        this._data = response.data;
        this._links = response.links;
        this._meta = response.meta;
    }

    parseResponse() {
        return {
            data: this.parseJson(this._data),
            links: this._links,
            meta: this._meta
        }
    }

    /**
     * Discriminates if the object type is array and calls to map
     *
     * @param data
     * @returns {*&{id: *}}
     */
    parseJson(data) {
        let tmp;

        if (!Array.isArray(data)) {
            tmp = this.mapObject(data);
        } else {
            tmp = data.map((t) => this.mapObject(t));
        }

        return tmp;
    }

    /**
     * Build object like "laravel" and parse relationships
     *
     * @param data
     * @returns {*&{id: *}}
     */
    mapObject(data) {
        let tmp = {id: data.id, ...data.attributes};

        if (data.relationships !== undefined) {
            tmp = {...tmp, ...this.mapRelations(data.relationships)};
        }

        return tmp;
    }

    /**
     * Build relations object
     *
     * @param relationships
     * @returns {{}}
     */
    mapRelations(relationships) {
        let tmp = {};

        // Go through each object to get relation name
        for (let key in relationships) {
            let relations = relationships[key].data;

            if (Array.isArray(relations)) {
                tmp[key] = relations.map((relation) => this.findObject(relation));
            } else {
                tmp[key] = this.findObject(relations);
            }
        }

        return tmp;
    }

    /**
     * Find object in included
     *
     * @param object
     * @returns {*}
     */
    findObject(object) {
        object = this._included.find((o) => o.type === object.type && o.id === object.id);

        return this.parseJson(object);
    }
}
